import { createApp } from 'vue'
import './theme.min.css'
// import './style.css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js' // JS 필요 시

const app = createApp(App)
const pinia = createPinia()
app.use(router)
app.use(pinia)
app.mount('#app')


app.config.errorHandler = (err, vm, info) => {
  console.error('Vue ErrorHandler:', err, info)
}
